import { com } from '@eidu/form'
import { useParams } from 'react-router-dom'
import { requireNotUndefinedOrNull } from '../../util/require'
import LoadingOverlay from '../../components/feedback/LoadingOverlay'
import EntityTypeNotAccessibleError from './EntityTypeNotAccessibleError'
import { getKindPageConfig } from './kindViewRegistry'
import useEntity from './useEntity'
import EntityId = com.eidu.sharedlib.entity.EntityId
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import entityIdFromString = com.eidu.sharedlib.entity.entityIdFromString
import entityTypeIdFromString = com.eidu.sharedlib.entity.type.entityTypeIdFromString

type CreateOrEditPageProps = {
  entityId: EntityId | undefined
  entityTypeId: EntityTypeId
}

const CreateOrEditPage = ({ entityId, entityTypeId }: CreateOrEditPageProps) => {
  const { entityType, entityTypes, entity, entityRepository, loading } = useEntity({ entityTypeId, entityId })

  const EditPage = entityType ? getKindPageConfig(entityType.kind).EditPage : undefined

  return (
    <>
      {entityType && entityTypes && EditPage && (
        <EditPage
          entity={entity}
          entityId={entityId}
          entityType={entityType}
          entityTypes={entityTypes}
          entityRepository={entityRepository}
          loading={loading}
        />
      )}
      {!loading && (!entityType || !entityTypes || !EditPage) && <EntityTypeNotAccessibleError />}
      <LoadingOverlay isOpen={loading} />
    </>
  )
}

const CreateOrEditPageRoute = () => {
  const params = useParams()
  const entityTypeId = entityTypeIdFromString(requireNotUndefinedOrNull(params.entityTypeId))
  const entityId = params.entityId?.let(entityIdFromString)

  return <CreateOrEditPage entityTypeId={entityTypeId} entityId={entityId} />
}

export default CreateOrEditPageRoute
